// This file provides mapping utilities for airport codes to city names and coordinates

// Airport to city mapping object
const airportToCityMap: { [code: string]: string } = {
  JFK: "New York",
  LAX: "Los Angeles",
  LHR: "London",
  CDG: "Paris",
  SYD: "Sydney",
  DXB: "Dubai",
  HND: "Tokyo",
  FRA: "Frankfurt",
  AMS: "Amsterdam",
  MAD: "Madrid",
  FCO: "Rome",
  YYZ: "Toronto",
  MUC: "Munich",
  SFO: "San Francisco",
  SIN: "Singapore",
  BKK: "Bangkok",
  BCN: "Barcelona",
  DEL: "New Delhi",
  IST: "Istanbul",
  MIA: "Miami",
  SEA: "Seattle",
  BOS: "Boston",
  ORD: "Chicago",
  DFW: "Dallas",
  ATL: "Atlanta",
  PEK: "Beijing",
  PVG: "Shanghai",
  CGK: "Jakarta",
  KUL: "Kuala Lumpur",
  MEX: "Mexico City",
  GRU: "São Paulo",
  EZE: "Buenos Aires",
  SCL: "Santiago",
  JNB: "Johannesburg",
  CAI: "Cairo",
  TLV: "Tel Aviv",
  HKG: "Hong Kong",
  ICN: "Seoul",
  BNE: "Brisbane",
  MEL: "Melbourne",
  AKL: "Auckland",
  CPT: "Cape Town",
  MNL: "Manila",
  TPE: "Taipei",
  VIE: "Vienna",
  ZRH: "Zurich",
  GVA: "Geneva",
  OSL: "Oslo",
  CPH: "Copenhagen",
  ARN: "Stockholm",
  HEL: "Helsinki",
  LIS: "Lisbon",
  ATH: "Athens",
  BRU: "Brussels",
  WAW: "Warsaw",
  PRG: "Prague",
  BUD: "Budapest",
  DUB: "Dublin",
  KEF: "Reykjavik",
  EDI: "Edinburgh",
  OTP: "Bucharest",
  SOF: "Sofia",
  VNO: "Vilnius",
  RIX: "Riga",
  TLL: "Tallinn",
  BEG: "Belgrade",
  SKP: "Skopje",
  TIA: "Tirana",
  OPO: "Porto",
  MLA: "Malta",
  LCA: "Larnaca",
  BHX: "Birmingham",
  MAN: "Manchester",
  GLA: "Glasgow",
  NCE: "Nice",
  MRS: "Marseille",
  TLS: "Toulouse",
  LYS: "Lyon",
  HAM: "Hamburg",
  STR: "Stuttgart",
  DUS: "Düsseldorf",
  CGN: "Cologne",
  NAP: "Naples",
  PMO: "Palermo",
  TRN: "Turin",
  GOA: "Genoa",
  VCE: "Venice",
  BLQ: "Bologna",
  PSA: "Pisa",
  CTA: "Catania",
  BRI: "Bari",
  VLC: "Valencia",
  AGP: "Málaga",
  SVQ: "Seville",
  BIO: "Bilbao",
  LPA: "Gran Canaria",
  TFS: "Tenerife",
  PMI: "Palma de Mallorca",
  OVD: "Asturias",
  XRY: "Jerez",
  GRX: "Granada",
  SAN: "San Diego",
  PHX: "Phoenix",
  LAS: "Las Vegas",
  MSP: "Minneapolis",
  DTW: "Detroit",
  PHL: "Philadelphia",
  CLT: "Charlotte",
  BWI: "Baltimore",
  IAD: "Washington DC",
  DCA: "Washington DC",
  IAH: "Houston",
  MCO: "Orlando",
  TPA: "Tampa",
  FLL: "Fort Lauderdale",
  RSW: "Fort Myers",
  PBI: "West Palm Beach",
  JAX: "Jacksonville",
  SAV: "Savannah",
  CHS: "Charleston",
  RDU: "Raleigh",
  PIT: "Pittsburgh",
  CLE: "Cleveland",
  CVG: "Cincinnati",
  IND: "Indianapolis",
  MKE: "Milwaukee",
  STL: "St. Louis",
  MCI: "Kansas City",
  OMA: "Omaha",
  DSM: "Des Moines",
  MSY: "New Orleans",
  BHM: "Birmingham",
  HSV: "Huntsville",
  BNA: "Nashville",
  MEM: "Memphis",
  SLC: "Salt Lake City",
  ABQ: "Albuquerque",
  TUS: "Tucson",
  ONT: "Ontario",
  SJC: "San Jose",
  SMF: "Sacramento",
  PDX: "Portland",
  BOI: "Boise",
  MSN: "Madison"
};

// Airport to coordinates mapping object
const airportToCoordinatesMap: { [code: string]: {lat: number, lng: number} } = {
  JFK: {lat: 40.6413, lng: -73.7781},
  LAX: {lat: 33.9416, lng: -118.4085},
  LHR: {lat: 51.4700, lng: -0.4543},
  CDG: {lat: 49.0097, lng: 2.5479},
  SYD: {lat: -33.9399, lng: 151.1753},
  DXB: {lat: 25.2532, lng: 55.3657},
  HND: {lat: 35.5494, lng: 139.7798},
  FRA: {lat: 50.0379, lng: 8.5622},
  AMS: {lat: 52.3105, lng: 4.7683},
  MAD: {lat: 40.4983, lng: -3.5676},
  FCO: {lat: 41.8045, lng: 12.2508},
  YYZ: {lat: 43.6777, lng: -79.6248},
  MUC: {lat: 48.3537, lng: 11.7860},
  SFO: {lat: 37.6213, lng: -122.3790},
  SIN: {lat: 1.3644, lng: 103.9915},
  BKK: {lat: 13.6900, lng: 100.7501},
  BCN: {lat: 41.2974, lng: 2.0833},
  DEL: {lat: 28.5562, lng: 77.1000},
  IST: {lat: 41.2608, lng: 28.7418},
  MIA: {lat: 25.7932, lng: -80.2906},
  SEA: {lat: 47.4426, lng: -122.3081},
  BOS: {lat: 42.3601, lng: -71.0589},
  ORD: {lat: 41.9028, lng: -87.6233},
  DFW: {lat: 32.8316, lng: -97.0400},
  ATL: {lat: 33.7488, lng: -84.3877},
  PEK: {lat: 39.9042, lng: 116.4074},
  PVG: {lat: 31.2304, lng: 121.4730},
  CGK: {lat: -6.1750, lng: 106.8270},
  KUL: {lat: 1.3522, lng: 103.8190},
  MEX: {lat: 19.4326, lng: -99.1332},
  GRU: {lat: -23.5502, lng: -46.6365},
  EZE: {lat: -34.6037, lng: -58.3815},
  SCL: {lat: -34.9126, lng: -60.6437},
  JNB: {lat: -26.1883, lng: 17.4178},
  CAI: {lat: 29.9756, lng: 31.1315},
  TLV: {lat: 31.7917, lng: 34.7850},
  HKG: {lat: 22.2862, lng: 114.1578},
  ICN: {lat: 37.5665, lng: 126.9780},
  BNE: {lat: -25.2744, lng: 153.0000},
  MEL: {lat: -26.2046, lng: 144.1426},
  AKL: {lat: -36.8489, lng: 174.7633},
  CPT: {lat: -34.0522, lng: 18.4168},
  MNL: {lat: 12.9517, lng: 121.5442},
  TPE: {lat: 25.0471, lng: 121.5167},
  DPS: {lat: -8.5790, lng: 115.1333},
  ONT: {lat: 43.6532, lng: -79.3832},
  SJC: {lat: 37.3394, lng: -121.8860},
  SMF: {lat: 37.7749, lng: -122.4194},
  PDX: {lat: 45.5231, lng: -122.6765},
  BOI: {lat: 44.9795, lng: -116.4183},
  MSN: {lat: 42.3601, lng: -71.0589}
};

// Airport to country mapping object
const airportToCountryMap: { [code: string]: string } = {
  JFK: "United States",
  LAX: "United States",
  LHR: "United Kingdom",
  CDG: "France",
  SYD: "Australia",
  DXB: "United Arab Emirates",
  HND: "Japan",
  FRA: "Germany",
  AMS: "Netherlands",
  MAD: "Spain",
  FCO: "Italy",
  YYZ: "Canada",
  MUC: "Germany",
  SFO: "United States",
  SIN: "Singapore",
  BKK: "Thailand",
  BCN: "Spain",
  DEL: "India",
  IST: "Turkey",
  MIA: "United States",
  SEA: "United States",
  BOS: "United States",
  ORD: "United States",
  DFW: "United States",
  ATL: "United States",
  PEK: "China",
  PVG: "China",
  CGK: "Indonesia",
  KUL: "Malaysia",
  MEX: "Mexico",
  GRU: "Brazil",
  EZE: "Argentina",
  SCL: "Chile",
  JNB: "South Africa",
  CAI: "Egypt",
  TLV: "Israel",
  HKG: "Hong Kong",
  ICN: "South Korea",
  BNE: "Australia",
  MEL: "Australia",
  AKL: "New Zealand",
  CPT: "South Africa",
  MNL: "Philippines",
  TPE: "Taiwan",
  DPS: "Indonesia",
};

/**
 * Gets the city name for a given airport code
 * @param code The IATA airport code (e.g., JFK, LAX)
 * @returns The city name or "Unknown City" if not found
 */
export function getCityFromAirportCode(code: string): string {
  if (!code) return "Unknown City";
  const upperCode = code.toUpperCase();
  return airportToCityMap[upperCode] || "Unknown City";
}

/**
 * Gets the country for a given airport code
 * @param code The IATA airport code (e.g., JFK, LAX)
 * @returns The country name or null if not found
 */
export async function getAirportCountry(code: string): Promise<string | null> {
  if (!code) return null;
  const upperCode = code.toUpperCase();
  console.debug(`🌍 getAirportCountry: Looking up country for airport code: ${upperCode}`);
  
  const country = airportToCountryMap[upperCode];
  if (country) {
    console.debug(`✅ getAirportCountry: Found country for ${upperCode}: ${country}`);
    return country;
  }
  
  console.debug(`⚠️ getAirportCountry: No country found for airport code: ${upperCode}`);
  return null;
}

/**
 * Gets the coordinates for a given airport code
 * @param code The IATA airport code (e.g., JFK, LAX)
 * @returns Object with lat and lng or null if not found
 */
export function getCoordinatesFromAirportCode(code: string): {lat: number, lng: number} | null {
  if (!code) return null;
  const upperCode = code.toUpperCase();
  return airportToCoordinatesMap[upperCode] || null;
}

/**
 * Checks if an airport code exists in our mapping
 * @param code The IATA airport code
 * @returns Boolean indicating if the code exists
 */
export function isValidAirportCode(code: string): boolean {
  if (!code) return false;
  const upperCode = code.toUpperCase();
  return !!airportToCityMap[upperCode];
}
